module.exports = __webpack_public_path__ + "static/media/01B.5d4970e5.png";